import { mutatorAction } from 'satcheljs';
import { Calendar, getCalendarEntry } from 'owa-calendar-cache';
import { findIndexToInsertCalendarAt } from '../utils/findIndexToInsertCalendarAt';

export let pushCalendar = mutatorAction(
    'pushCalendar',
    (calendars: Calendar[], newCalendar: Calendar) => {
        calendars.push(newCalendar);
    }
);

export let addCalendarAtIndex = mutatorAction(
    'addCalendarAtIndex',
    (calendars: Calendar[], newCalendar: Calendar) => {
        if (newCalendar) {
            const calendarEntry = getCalendarEntry(newCalendar);
            const index = findIndexToInsertCalendarAt(
                calendars,
                newCalendar.id.mailboxInfo.userIdentity,
                calendarEntry?.ParentGroupId
            );
            calendars.splice(index, 0, newCalendar);
        }
    }
);

export let spliceCalendar = mutatorAction(
    'spliceCalendar',
    (calendars: Calendar[], index: number) => {
        calendars.splice(index, 1);
    }
);
